// The same public snapshot seeds server output and the first hydration render.
// Effects refresh it from the existing APIs after hydration; no private data.
export const getBuildSnapshot = () => globalThis.__VVPSS_SNAPSHOT__ || {};
export const getBasePath = () => globalThis.__VVPSS_BASE_PATH__ || "";
export const assetUrl = (url) => url?.startsWith("/") && !url.startsWith("//") && !url.startsWith("/api/")
    ? `${getBasePath()}${url}` : url;